<template>
  <div
    class="container"
    :style="
      $route.query.welcome == 'false' || !$route.query.welcome ? navHeight : ''
    "
  >
    <transition name="fade" mode="out-in">
      <div class="h-100 row" v-if="logged && routerParam0 != '' && fetched">
        <transition name="fade" mode="out-in">
          <plans-viewer
            v-if="routerParam0 == 'plans'"
            class="h-100 col-12 col-md-8 col-xl-7"
            :collectionDBname="routerParam0"
          />

          <objects-viewer
            v-else-if="
              routerParam0 != '' && fetched && routerParam0 != 'account'
            "
            class="col-12 col-md-8 col-xl-7 mx-auto"
            :collectionDBname="routerParam0"
          />
          <account-viewer
            v-else-if="routerParam0 != '' && fetched"
            class=" col-12 col-md-8 col-xl-7 mx-auto"
            :collectionDBname="routerParam0"
          />
        </transition>
      </div>
    </transition>
  </div>
</template>
<script>
import ObjectsViewer from "@/components/ObjectViewer"
import PlansViewer from "@/components/PlansViewer"
import AccountViewer from "@/components/AccountViewer"
import { mapGetters, mapActions } from "vuex"
export default {
  props: ["navHeight"],
  computed: {
    ...mapGetters([
      "fetched",
      "countries",
      "logged",
      "colorScheme",
      "navStyle",
    ]),
  },
  mounted() {
    console.log("MONTADO EL VIEWER BIG")
    window.scrollTo({ top: 0, behavior: "smooth" })
    if (this.logged) {
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: "white",
        color: this.colorScheme.dark,
        boxShadow: "0 3px 6px 0 rgba(0,0,0,0.15)",
      })
    } else {
      this.$router.push("/")
    }
    this.routerParam0 = this.$route.params.param0
    this.getObjects(this.$route.params.param0)
  },
  components: {
    ObjectsViewer,
    PlansViewer,
    AccountViewer,
  },
  methods: {
    ...mapActions(["FETCH_countries", "SET_NAVSTYLE"]),
    async getObjects(collectionDBname) {
      console.log("GETTING OBJECTS", this.$store, collectionDBname)
      await this.$store.dispatch(`FETCH_${collectionDBname}`).then(state => {
        console.log("GETTING OBJECTS STATE", state)
        /* if (state == true) {
          this.isLoading = false
        } */
        this.isLoading = true
      })

      //const actionStore = this.$store.
    },
  },
  watch: {
    //para actualizar componente en cambio de ruta
    async $route(to /*, from*/) {
      const routerParameter = to.params.param0
      this.routerParam0 = routerParameter
      console.log("WACHING ROUTE", routerParameter)
      window.scrollTo({ top: 0, behavior: "smooth" })
      await this.getObjects("profile")
      await this.getObjects(routerParameter)
      if (!this.countries) {
        this.FETCH_countries()
      }
    },
  },
  data() {
    //
    return {
      routerParam0: "",
    }
  },
}
</script>
